import type { CSSProperties } from "react";
import { cx } from "./fieldContext";
const LINE_HEIGHT = 12;

export type SkeletonBlock = {
  /** Höhe in px oder CSS-Länge. */
  height: number | string;
  /** Breite (Standard: volle Breite). */
  width?: number | string;
  /** Rund (Avatar/Symbol) statt Rechteck. */
  round?: boolean;
};

export interface SkeletonProps {
  /** Formen in Lesereihenfolge; sie deuten den späteren Inhalt an. */
  blocks?: SkeletonBlock[];
  /** Kurzform: so viele Textzeilen (letzte kürzer). */
  lines?: number;
  /** Zugänglicher Name, z. B. „Kampagnen werden geladen“. */
  label?: string;
  className?: string;
  style?: CSSProperties;
}

const size = (value: number | string | undefined) => (typeof value === "number" ? `${value}px` : value);

/**
 * Platzhalter in Form des späteren Inhalts statt Ladekreisel. Farben aus dem Theme (`--mq-theme-fill`),
 * Schimmer bei reduzierter Bewegung aus.
 */
export function Skeleton({ blocks, lines = 3, label, className, style }: SkeletonProps) {
  const shapes: SkeletonBlock[] = blocks ?? Array.from({ length: lines }, (_, index) => ({ height: LINE_HEIGHT, width: index === lines - 1 && lines > 1 ? "60%" : "100%" }));
  return (
    <div className={cx("ck-skeleton", className)} style={style} role="status" aria-live="polite" aria-label={label} aria-busy="true">
      {shapes.map((shape, index) => (
        <span
          key={index}
          className={cx("ck-skeleton-block", shape.round && "ck-skeleton-block--round")}
          style={{ height: size(shape.height), width: size(shape.width ?? "100%") }}
        />
      ))}
    </div>
  );
}
